<button mat-menu-item 
    class="d-flex align-items-center"
    (click)="toggleProjectView($event)">
    <mat-icon class="d-flex align-items-center justify-content-center me-3">{{isProjectViewEnabled? 'done' : ''}}</mat-icon>
    <span>{{'PROJECT_VIEW' | translate}}</span>
</button>

<button mat-menu-item (click)="onSaveCurrentWorkspace()">
    <span class="ps-5">{{'SAVE_CURRENT_WORKSPACE' | translate}}</span>
</button>
<button mat-menu-item (click)="onResetCurrentWorkspace()">
    <span class="ps-5">{{'RESET_CURRENT_WORKSPACE' | translate}}</span>
</button>
<button mat-menu-item (click)="onResetFactoryWorkspace()">
    <span class="ps-5">{{'RESET_FACTORY_WORKSPACE' | translate}}</span>
</button>